import NewHireForm from "@/components/Forms/NewHire/NewHireForm";

const NewHireDetail = (): JSX.Element => {
  return <NewHireForm />;
};

export default NewHireDetail;